export default __webpack_public_path__ + "static/media/toggleLiveDataActiveIcon.6c61cf2a.svg";